import { styled } from '@mui/material/styles';
import { Typography, Divider } from '@mui/material';

export const StatisticsTitle = styled(Typography)({
  color: 'black',
  fontWeight: '500'
});

export const RewardsTitle = styled(Typography)({
  fontWeight: '500'
});

export const StyledDivider = styled(Divider)({
  height: '50%',
  alignSelf: 'center'
}); 